import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { MissingParamError } from "../../utils/erros/erros";

export class DominioHttpGateway {
    HttpAdapter = new HttpAdapter();
    baseUrlDataCommunications = `${publicSettings.aws.baseUrls.dataCommunications}/data-communications`;
    baseUrlDataSources = `${publicSettings.aws.baseUrls.dataSources}`;

    constructor() {}

    async getAppLink() {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataCommunications}/dominio/latest-version`
            );
            return response?.url;
        } catch (error) {
            return "";
        }
    }

    /**
     * As instalações do Nucont Conector da contabilidade, com a situação, a próxima busca de pedidos e
     * até quando vão os dados. `null` quando a rota falha: a tela segue sem a faixa do conector.
     */
    async getConnectorStatus({ accountingId } = {}) {
        if (!accountingId) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/dominio/v2/conectores`,
                { accountingId }
            );
            return Array.isArray(response?.installations) ? response : null;
        } catch (error) {
            return null;
        }
    }

    /**
     * Muda as chaves do contábil de uma empresa (`empresa/chaves`). A contabilidade e a empresa vão nos cabeçalhos
     * `accounting-id` e `company-id`, que o back confere contra o login: sem o `accounting-id`, ele compara a empresa
     * com a contabilidade do login, vazia para a equipe NUCONT. Devolve a resposta como veio: `{ companyId, options }`,
     * ou o erro do back.
     */
    async setCompanyOptions({ accountingId, companyId, change } = {}) {
        if (!accountingId) throw new MissingParamError("accountingId");
        if (!companyId) throw new MissingParamError("companyId");
        return await this.HttpAdapter.call(
            `${this.baseUrlDataSources}/dominio/v2/empresa/chaves`,
            change,
            { headers: { "accounting-id": accountingId, "company-id": companyId } }
        );
    }
}
